import './lib/akoa-api';
const entryContext = require.context('./entry', false, /\.(?:js|ts)$/, 'lazy');
const normalizeEntryName = (entry) => entry.replace(/^\.?\//, '').replace(/\.(?:js|ts)$/, '');
const entryKeysByName = new Map(entryContext.keys().map((key) => [normalizeEntryName(key), key]));
const entryImports = new Map();
const visibleMarkers = new WeakMap();
const markerSelector = 'template[data-island-entry]';
let visibleObserver = null;
function importEntry(entry) {
    const entryName = normalizeEntryName(entry);
    const existingImport = entryImports.get(entryName);
    if (existingImport) {
        return existingImport;
    }
    const key = entryKeysByName.get(entryName);
    if (!key) {
        console.warn(`Unknown island entry: ${entry}`);
        return Promise.resolve();
    }
    const entryImport = Promise.resolve(entryContext(key)).catch((error) => {
        entryImports.delete(entryName);
        console.error(`Unable to load island entry: ${entry}`, error);
    });
    entryImports.set(entryName, entryImport);
    return entryImport;
}
function loadMarker(marker) {
    const entry = marker.dataset.islandEntry;
    return entry ? importEntry(entry) : Promise.resolve();
}
function getVisibleObserver() {
    if (visibleObserver || !('IntersectionObserver' in window)) {
        return visibleObserver;
    }
    visibleObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting)
                return;
            const markers = visibleMarkers.get(entry.target) || [];
            markers.forEach(loadMarker);
            visibleMarkers.delete(entry.target);
            observer.unobserve(entry.target);
        });
    });
    return visibleObserver;
}
function scheduleVisible(marker) {
    const observer = getVisibleObserver();
    const target = marker.closest('[data-island-root]') || marker.parentElement;
    if (!observer || !target) {
        loadMarker(marker);
        return;
    }
    const markers = visibleMarkers.get(target) || [];
    markers.push(marker);
    visibleMarkers.set(target, markers);
    observer.observe(target);
}
function scheduleIdle(marker) {
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => loadMarker(marker), { timeout: 2000 });
        return;
    }
    globalThis.setTimeout(() => loadMarker(marker), 1);
}
function scheduleMarker(marker) {
    if (marker.dataset.islandState === 'scheduled')
        return;
    marker.dataset.islandState = 'scheduled';
    switch (marker.dataset.islandLoad) {
        case 'visible':
            scheduleVisible(marker);
            break;
        case 'idle':
            scheduleIdle(marker);
            break;
        default:
            loadMarker(marker);
    }
}
export function scan(root = document) {
    if (root instanceof HTMLTemplateElement && root.matches(markerSelector)) {
        scheduleMarker(root);
    }
    root
        .querySelectorAll(markerSelector)
        .forEach(scheduleMarker);
}
scan();
document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) {
        scan(event.target);
    }
});
